export enum GenericDataResourceActionTypeEnum {
  Put = '@quidproquo-webserver/genericDataResource/Put',
  Scan = '@quidproquo-webserver/genericDataResource/Scan',
}

export default GenericDataResourceActionTypeEnum;
